import React from "react";
import { ContextMenu, ContextMenuTrigger } from "@/components/ui/context-menu";
import { RowContextMenuContent } from "@/components/shared/UniversalCRMTable/components/SimpleTable/RowContextMenuContent";
import { useTaskHooks } from "@/lib/hooks/api/shared/graphql-hooks";
import { getEntityTableConfig } from "@/lib/entity-registry";
import type { ContactTaskRow } from "@/lib/types/entity-rows";

const TASK_CONFIG = getEntityTableConfig<ContactTaskRow>("tasks");

interface UnifiedTaskRowContextMenuProps {
  task: ContactTaskRow;
  children: React.ReactNode;
}

/**
 * Right-click context menu for a task row/card. Reuses `taskDetailActions` via
 * the registry and `RowContextMenuContent`, so the same canonical action
 * handlers fire from a right-click exactly as they do from the ⋯ button.
 *
 * See: `.claude/rules/ENTITY_TABLE_ROW_ACTIONS.md`,
 *      `.claude/rules/main-RADIX-ASCHILD.md`
 */
export function UnifiedTaskRowContextMenu({
  task,
  children,
}: UnifiedTaskRowContextMenuProps) {
  const taskHooks = useTaskHooks();
  const detailActions = TASK_CONFIG.detailActions || [];

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <RowContextMenuContent
        item={task}
        actions={detailActions}
        hooks={taskHooks}
        entityName="tasks"
        config={TASK_CONFIG}
      />
    </ContextMenu>
  );
}
